import React from "react";
import { Text } from "@chakra-ui/react";
import { Modal } from "newui/components/ui/Modal";

interface ConfirmDecisionDialogProps {
	isOpen: boolean;
	isSubmitting: boolean;
	title: string;
	body: string;
	confirmLabel: string;
	onCancel: () => void;
	onConfirm: () => void;
}

/**
 * Outcome-aware confirmation gate shown before any award / not-awarded
 * mutation is dispatched (PRO-655: title/body differ for the preferred vs.
 * unsuccessful outcome — see CONFIRM_DECISION_*_PREFERRED / *_UNSUCCESSFUL in
 * awardDecisions.ts). The confirm button is disabled (and shows a loading
 * state) while the mutation is in flight so the action cannot be double-fired.
 */
export const ConfirmDecisionDialog = ({
	isOpen,
	isSubmitting,
	title,
	body,
	confirmLabel,
	onCancel,
	onConfirm,
}: ConfirmDecisionDialogProps) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onCancel}
			title={title}
			iconType="warning"
			closeOnOverlayClick={!isSubmitting}
			closeOnEsc={!isSubmitting}
			primaryButton={{
				text: confirmLabel,
				onClick: onConfirm,
				isLoading: isSubmitting,
				disabled: isSubmitting,
			}}
			secondaryButton={{
				text: "Cancel",
				onClick: onCancel,
				disabled: isSubmitting,
			}}
		>
			<Text data-testid="confirm-decision-body">{body}</Text>
		</Modal>
	);
};
